import React, { useEffect } from 'react'
import NativeModal from '../WrapperComponent/NativeModal'
import useAccessToken from '../../hooks/AccessToken'
import { readNotificationUser } from '../../api/LogsCRUD'
import { Notification } from '../../interfaces/NotificationLog/notification'
import { Link } from "react-router-dom";
import useRedirectRouteNotif from '../../stores/RedirectRouteNotif'
import { useIntl } from 'react-intl'
import useUser from '../../hooks/User'
import { Modal } from 'rsuite'
import { useSettingsStore } from '../../stores/SettingsStore'

interface DetailNotificationLogProps {
    notification: Notification
    onClose: () => void
    open: boolean
    mutate: () => void
}

const DetailNotificationLog = ({ notification, onClose, open, mutate }: DetailNotificationLogProps) => {
    const token = useAccessToken()
    const listTypeNotif = ['REIMBURSEMENT.INFO', 'MEETING.INFO', 'PIPELINE.INFO']
    const { setRedirectRouteNotif } = useRedirectRouteNotif()
    const intl = useIntl()
    const user = useUser()
    const { settings } = useSettingsStore()

    useEffect(() => {
        if (notification?.readtime === null) {
            const readNotification = async () => {
                const response = await readNotificationUser(notification.id, token)
                if (response.data.success) {
                    mutate()
                }
            }
            readNotification()
        }
    }, [notification, token])

    useEffect(() => {
        const getRsModalWrapper: HTMLDivElement | null = document.querySelector('.rs-modal-wrapper')
        if (getRsModalWrapper) {
            getRsModalWrapper.style.display = 'flex'
            getRsModalWrapper.style.alignItems = 'center'
            getRsModalWrapper.style.justifyContent = 'center'
        }
    }, [])

    const validationRedirectRoute = () => {
        if (user.data.has_subordinate && listTypeNotif.includes(notification.type) && notification.onClickRoute) {
            return true
        } else if (notification.type !== 'MEETING.INFO' && notification.onClickRoute) {
            return true
        }
        return false
    }

    const getTypeNotif = (type: string) => {
        if (type === 'REIMBURSEMENT.INFO') {
            return intl.formatMessage({ id: "FORM.MENU.REIMBURSEMENTS" })
        } else if (type === 'MEETING.INFO') {
            return settings.meeting_title
        } else if (type === "PIPELINE.INFO") {
            return settings.pipeline_title
        }
        return 'Data'
    }

    return (
        <Modal open={open} onClose={onClose} size={'sm'}>
            <div className='modal-header'>
                <h5 className='modal-title'>{notification?.title}</h5>
                <button type='button' className='btn-close' onClick={onClose} aria-label="Close" />
            </div>
            <div className='modal-body'>
                <p>{notification?.body}</p>
                {
                    validationRedirectRoute() &&
                    (
                        <Link
                            to={notification.onClickRoute}
                            onClick={() => {
                                setRedirectRouteNotif(notification.datajson.id || '', notification.datajson.templateId || '')
                            }}
                            target='_blank'>{intl.formatMessage({ id: "FORM.LABEL.LOOK" })}
                        </Link>
                    )
                }
                {
                    !notification.onClickRoute && <p className='fw-bolder'>{getTypeNotif(notification.type)} ini telah dihapus dan tidak tersedia lagi</p>
                }
            </div>
            <div className='modal-footer'>
                <button type='button' className='btn btn-secondary' onClick={onClose}>
                    Close
                </button>
            </div>
        </Modal>
    )
}

export default DetailNotificationLog